export enum SimStatusPalette {
	success = "statusPalette-success",
	error = "statusPalette-error",
	warn = "statusPalette-warn",
	busy = "statusPalette-busy",
	inactive = "statusPalette-inactive",
}
